import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { useState, useEffect, useRef, useCallback } from 'react';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { Box, Typography, TextField } from '@mui/material';
import useResponsive from '../../hooks/useResponsive';
import useDebounce from '../../hooks/useDebounce';
import { fr } from 'date-fns/locale';
import Iconify from '../Iconify';
import '../../css/machines/MachineFiltration.css';

const DashboardFiltration = ({ showResponsiveFilter, setShowResponsiveFilter, filtersEmpty, filters, setFilters, totalSites, filteredSitesCount, sitesFetched }) => {

    const isDesktop = useResponsive('up', 'md');
    const containerRef = useRef(null); // To reference the filtration container

    const [search, setSearch] = useState(filters.debouncedSearch || '');
    const debouncedSearch = useDebounce(search, 1000);

    useEffect(() => {
        setFilters(prev => ({ ...prev, debouncedSearch }));
    }, [debouncedSearch, setFilters]);

    const handleResetFilters = useCallback(() => {
        setFilters({ search: '', selectedYear: '', selectedMonth: '' });
        setSearch('');
    }, [setFilters]);

    return (
        <Box className='MachineFiltration_main_Box'>
            {isDesktop &&
                <Box className='MachineFiltration_fix_mode_box'>
                    <Box className='MachineFiltration_search_Box'>
                        <TextField
                            size="small"
                            value={search}
                            placeholder='Rechercher'
                            onChange={(e) => setSearch(e.target.value)}
                            variant="outlined"
                            className='MachineFiltration_search_field'
                            InputProps={{
                                startAdornment: <Iconify icon={"bx:bx-search"} className='MachineFiltration_search_icon' />,
                                sx: {
                                    backgroundColor: '#fff',
                                    height: '36px',
                                    fontFamily: 'Mulish',
                                    color: '#201E1E',
                                    fontSize: '14px',
                                    fontWeight: 400,
                                },
                            }}
                        />
                        <LocalizationProvider dateAdapter={AdapterDateFns} locale={fr}>
                            <DatePicker
                                views={['year']}
                                label="Année"
                                value={filters.selectedYear ? new Date(filters.selectedYear, 0, 1) : null}
                                onChange={(newValue) =>
                                    setFilters({
                                        ...filters,
                                        selectedYear: newValue ? newValue.getFullYear() : '',
                                    })
                                }
                                renderInput={(params) => (
                                    <TextField className="addCompany_InputField" {...params} />
                                )}
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        backgroundColor: 'white',
                                        borderRadius: '8px',
                                        '&:hover': {
                                            borderColor: '#1976d2',
                                        },
                                        height: '36px',
                                    },
                                    // Center label when input is focused/filled
                                    '& .MuiInputLabel-root': {
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        left: '10px',
                                        pointerEvents: 'auto',
                                    },
                                    // Adjust label when shrinks/floats
                                    '& .MuiInputLabel-shrink': {
                                        top: 0,
                                    },
                                }}
                            />

                        </LocalizationProvider>
                        {filters.selectedYear &&
                            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={fr}>
                                <DatePicker
                                    views={['month']}
                                    label="Mois"
                                    value={filters.selectedMonth ? new Date(filters.selectedYear, filters.selectedMonth - 1, 1) : null}
                                    onChange={(newValue) => setFilters({
                                        ...filters,
                                        selectedMonth: newValue ? newValue.getMonth() + 1 : ''
                                    })}
                                    renderInput={(params) => <TextField {...params} />}
                                    sx={{
                                        '& .MuiOutlinedInput-root': {
                                            backgroundColor: 'white',
                                            borderRadius: '8px',
                                            '&:hover': {
                                                borderColor: '#1976d2',
                                            },
                                            height: '36px',
                                        },
                                        // Center label when input is focused/filled
                                        '& .MuiInputLabel-root': {
                                            top: '50%',
                                            transform: 'translateY(-50%)',
                                            left: '10px',
                                            pointerEvents: 'auto',
                                        },
                                        // Adjust label when shrinks/floats
                                        '& .MuiInputLabel-shrink': {
                                            top: 0,
                                        },
                                    }}
                                />
                            </LocalizationProvider>
                        }
                        <Typography className='MachineFiltration_clearAll' onClick={handleResetFilters}>Re-initialiser</Typography>
                    </Box>
                    <Box className='MachineFiltration_search_Box'>
                        <Typography className='MachineFiltration_total_number'>
                            {sitesFetched} affichés
                            {!filtersEmpty && ` / ${filteredSitesCount} filtrés`}
                            {` / ${totalSites} au total`}
                        </Typography>
                    </Box>
                </Box>
            }

            <Box className='MachineFiltration_wrapper'>
                {(isDesktop || showResponsiveFilter) &&
                    <Box ref={containerRef} className='MachineFiltration_container'>
                        {!isDesktop &&
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '10px', width: '100%' }}>
                                <TextField
                                    size="small"
                                    value={search}
                                    placeholder='Rechercher'
                                    onChange={(e) => setSearch(e.target.value)}
                                    variant="outlined"
                                    className='MachineFiltration_search_field'
                                    InputProps={{
                                        startAdornment: <Iconify icon={"bx:bx-search"} className='MachineFiltration_search_icon' />,
                                        sx: {
                                            backgroundColor: '#fff',
                                            height: '36px',
                                            fontFamily: 'Mulish',
                                            color: '#201E1E',
                                            fontSize: '14px',
                                            fontWeight: 400,
                                        },
                                    }}
                                />
                                <LocalizationProvider dateAdapter={AdapterDateFns} locale={fr}>
                                    <DatePicker
                                        views={['year']}
                                        label="Année"
                                        value={filters.selectedYear ? new Date(filters.selectedYear, 0, 1) : null}
                                        onChange={(newValue) =>
                                            setFilters({
                                                ...filters,
                                                selectedYear: newValue ? newValue.getFullYear() : '',
                                            })
                                        }
                                        renderInput={(params) => (
                                            <TextField {...params} />
                                        )}
                                        sx={{
                                            '& .MuiOutlinedInput-root': {
                                                backgroundColor: 'white',
                                                borderRadius: '8px',
                                                '&:hover': {
                                                    borderColor: '#1976d2',
                                                },
                                                height: '36px',
                                                width: '100%'
                                            },
                                            // Center label when input is focused/filled
                                            '& .MuiInputLabel-root': {
                                                top: '50%',
                                                transform: 'translateY(-50%)',
                                                left: '10px',
                                                pointerEvents: 'auto',
                                            },
                                            // Adjust label when shrinks/floats
                                            '& .MuiInputLabel-shrink': {
                                                top: 0,
                                            },
                                        }}
                                    />

                                </LocalizationProvider>
                                {filters.selectedYear &&
                                    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={fr}>
                                        <DatePicker
                                            views={['month']}
                                            label="Mois"
                                            value={filters.selectedMonth ? new Date(filters.selectedYear, filters.selectedMonth - 1, 1) : null}
                                            onChange={(newValue) => setFilters({
                                                ...filters,
                                                selectedMonth: newValue ? newValue.getMonth() + 1 : ''
                                            })}
                                            renderInput={(params) => <TextField {...params} />}
                                            sx={{
                                                '& .MuiOutlinedInput-root': {
                                                    backgroundColor: 'white',
                                                    borderRadius: '8px',
                                                    '&:hover': {
                                                        borderColor: '#1976d2',
                                                    },
                                                    height: '36px',
                                                },
                                                // Center label when input is focused/filled
                                                '& .MuiInputLabel-root': {
                                                    top: '50%',
                                                    transform: 'translateY(-50%)',
                                                    left: '10px',
                                                    pointerEvents: 'auto',
                                                },
                                                // Adjust label when shrinks/floats
                                                '& .MuiInputLabel-shrink': {
                                                    top: 0,
                                                },
                                            }}
                                        />
                                    </LocalizationProvider>
                                }
                            </Box>
                        }
                    </Box>
                }

                {!isDesktop &&
                    <Box className='MachineFiltration_filter_icon_ButtonGroup_box'>

                        <Box className='MachineFiltration_filter_icon_export_box'>
                            <Iconify
                                className='MachineFiltration_filter_icon'
                                icon={"cil:filter"}
                                backgroundColor={showResponsiveFilter ? '#182E45' : '#fffff'}
                                color={showResponsiveFilter ? '#ffffff' : '#201E1E'}
                                onClick={() => setShowResponsiveFilter(!showResponsiveFilter)}
                            />
                        </Box>

                        <Typography className='MachineFiltration_clearAll' onClick={handleResetFilters}>Re-initialiser</Typography>

                        <Typography className='MachineFiltration_total_number'>
                            {sitesFetched} affichés
                            {!filtersEmpty && ` / ${filteredSitesCount} filtrés`}
                            {` / ${totalSites} au total`}
                        </Typography>
                    </Box>
                }
            </Box>
        </Box>
    );
};

export default DashboardFiltration;